import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div<{
  $heightCompensation?: number
}>`
  display: flex;
  justify-content: center;
  width: 50%;
  background-color: ${Colors.Neutral10};
  min-height: calc(100vh - ${({ $heightCompensation }) => $heightCompensation || 0}px);

  ${Media.Laptop`
    width: 100%;
    margin: 0 auto;
  `};

  ${Media.Desktop`
    max-width: 860px;
  `};
`

export const LeftSide = styled.div`
  width: 100%;
  max-width: 100%;
  flex: 1;
`
